var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"grid"}},[_c('StatsInfo',{attrs:{"id":"StatsInfo"}}),_c('PNLByDayBarChart',{attrs:{"id":"PNLByDayBarChart"}}),_c('TotalPNLByDayChart',{attrs:{"id":"TotalPNLByDayChart"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }